import axios from 'axios'
import { last } from 'lodash-es'
import { forceFileDownload } from '@/services/utils/functions'
import { RESPONSE_TYPE_ARRAY_BUFFER } from '@/constants'

const ENDPOINTS = {
    FILE_DOWNLOAD: companyId => `companies/${companyId}/file`
}

class FileService {
    // `fileName` is the name the file is saved under. Pass it whenever the caller
    // knows the original name: stored attachment names are generated and carry no
    // meaning (CT-585), so the last path segment is not a name to show a user.
    async downloadFile (companyId, path, fileName = null) {
        try {
            const file = await axios.get(ENDPOINTS.FILE_DOWNLOAD(companyId), {
                params: { path },
                responseType: RESPONSE_TYPE_ARRAY_BUFFER
            })

            forceFileDownload(file, fileName || last(path.split('/')))
        } catch (error) {
            throw error
        }
    }
}

export const fileService = new FileService()
